// =====================================================================
// V4C autocomplete (Pattern A) for /search page
// =====================================================================
//
// 役割:
//   /search ページの検索フォームに focus / input イベントを attach し、
//   V4cClient.complete を 200ms debounce で叩いて Pattern A 統合 list を
//   描画する Web Component。
//
// modal 内 (assets/v4c-predictive-search.js) の buildSuggestionsHtml と
// 同じ HTML 構造を生成する。styles は snippets/v4c-suggestion-styles.liquid。
//
// マウント:
//   sections/v4c-search-suggestion.liquid が <v4c-search-suggestion> を出力。
//   templates/search.json の order で search-header と main の間に配置される。
// =====================================================================

(function () {
  if (customElements.get('v4c-search-suggestion')) return;

  function escapeHtml(s) {
    if (typeof s !== 'string') return '';
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getLabels() {
    var lang = (window.V4cClient && typeof window.V4cClient.getLocale === 'function')
      ? window.V4cClient.getLocale()
      : 'ja';
    switch (lang) {
      case 'en':    return { brand: 'Brand',  category: 'Category', query: 'Search'   };
      case 'es':    return { brand: 'Marca',  category: 'Categoría', query: 'Búsqueda' };
      case 'zh-CN': return { brand: '品牌',   category: '类别',      query: '搜索'    };
      case 'zh-TW': return { brand: '品牌',   category: '類別',      query: '搜尋'    };
      default:      return { brand: 'ブランド', category: 'カテゴリ',  query: '候補'    };
    }
  }

  // brand / category は targetHandle → canonical collection title (current locale 翻訳済)
  // を window.V4cCollectionTitles で逆引きして表示。alias 入力 (例: 「グッチ」「gucci」) で
  // ヒットしても chip / suggestion 表示は「GUCCI」など Shopify collection 上の正式名に統一。
  // window.V4cCollectionTitles は sections/v4c-search-results.liquid が inline script で
  // 注入する。
  function resolveDisplayText(c) {
    var map = window.V4cCollectionTitles;
    if (map && c.targetHandle && typeof map[c.targetHandle] === 'string') {
      return map[c.targetHandle];
    }
    return c.text || '';
  }

  function buildSuggestionsHtml(completions) {
    if (!completions || completions.length === 0) return '';
    var labels = getLabels();
    var lis = [];
    for (var i = 0; i < completions.length; i++) {
      var c = completions[i] || {};
      var type = c.type || 'query';
      var targetHandle = c.targetHandle || '';
      // brand / category は canonical title、query は入力したクエリ自体を尊重
      var text =
        (type === 'brand' || type === 'category')
          ? resolveDisplayText(c)
          : (c.text || '');
      if (!text) continue;

      var label, href;
      if (type === 'brand' || type === 'category') {
        label = type === 'brand' ? labels.brand : labels.category;
        href = targetHandle
          ? '/collections/' + encodeURIComponent(targetHandle)
          : '/search?q=' + encodeURIComponent(text);
      } else {
        label = labels.query;
        href = '/search?q=' + encodeURIComponent(text);
      }

      lis.push(
        '<li class="v4c-suggestion-row v4c-suggestion-row--' + type + '" role="option">' +
          '<a href="' + href + '" class="v4c-suggestion-row__link">' +
            '<span class="v4c-suggestion-row__text">' + escapeHtml(text) + '</span>' +
            '<span class="v4c-suggestion-row__label">' + escapeHtml(label) + '</span>' +
          '</a>' +
        '</li>'
      );
    }
    if (lis.length === 0) return '';
    return '<ul class="v4c-suggestion-list" role="listbox">' + lis.join('') + '</ul>';
  }

  function debounce(fn, ms) {
    var t = null;
    return function () {
      var ctx = this;
      var args = arguments;
      if (t) clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  class V4cSearchSuggestion extends HTMLElement {
    constructor() {
      super();
      this._gen = 0;
    }

    connectedCallback() {
      // 検索 input の探索:
      //   1) 自身の祖先に form があるならその input[name="q"] (legacy: section 内に
      //      form を含む構成のためのフォールバック)
      //   2) /search ページでは search-header section と v4c-search-suggestion section
      //      が別 DOM tree に分かれているため、document 全体から
      //      search-page-input-component (blocks/_search-input.liquid) 内の input を探す
      //   3) header の search modal の input は別物 (modal が closed のときは form 自体
      //      が DOM に存在しないので search-page-input-component を優先する)
      var input = null;
      var form = this.closest('form');
      if (form) input = form.querySelector('input[name="q"]');
      if (!input) {
        var sp = document.querySelector('search-page-input-component');
        if (sp) input = sp.querySelector('input[name="q"]');
      }
      if (!input) {
        // 最終フォールバック: ページ内の任意の name="q" input (header modal は除外、
        // modal が closed なら form は DOM 上に無いはず)
        input = document.querySelector('main input[name="q"], #MainContent input[name="q"]');
      }
      if (!input) {
        this.hidden = true;
        return;
      }
      this.input = input;

      var self = this;
      this._onInput = debounce(function () {
        self._positionAtInput();
        self._fetchAndRender();
      }, 200);
      this._onFocus = function () {
        self._positionAtInput();
        self._fetchAndRender();
      };
      this._onBlur = this._delayHide.bind(this);
      this._onReposition = function () {
        if (!self.hidden) self._positionAtInput();
      };

      this.input.addEventListener('input', this._onInput);
      this.input.addEventListener('focus', this._onFocus);
      this.input.addEventListener('blur', this._onBlur);

      // dropdown が表示中だけ位置を追従させる (scroll/resize で input が動いた場合)
      window.addEventListener('scroll', this._onReposition, { passive: true });
      window.addEventListener('resize', this._onReposition);

      // 直リンク (/search?q=...) で初期 input.value がある場合でも、フォーカス
      // するまでは dropdown を出さない (一般的な autocomplete UX)。
    }

    disconnectedCallback() {
      if (this.input) {
        this.input.removeEventListener('input', this._onInput);
        this.input.removeEventListener('focus', this._onFocus);
        this.input.removeEventListener('blur', this._onBlur);
      }
      if (this._onReposition) {
        window.removeEventListener('scroll', this._onReposition);
        window.removeEventListener('resize', this._onReposition);
      }
    }

    /**
     * <v4c-search-suggestion> を input の真下に position: fixed で配置する。
     * input の getBoundingClientRect を基準に top / left / width / max-height を設定。
     * scroll / resize / focus / input のたびに呼んで位置を追従させる。
     */
    _positionAtInput() {
      if (!this.input) return;
      var rect = this.input.getBoundingClientRect();
      // 4px ギャップを空けて input 直下
      this.style.position = 'fixed';
      this.style.top = (rect.bottom + 4) + 'px';
      this.style.left = rect.left + 'px';
      this.style.width = rect.width + 'px';
      this.style.maxHeight = Math.max(160, window.innerHeight - rect.bottom - 24) + 'px';
    }

    async _fetchAndRender() {
      if (!this.input) return;
      var q = this.input.value.trim();
      if (!q) {
        this._hide();
        return;
      }
      if (!window.V4cClient || typeof window.V4cClient.complete !== 'function') {
        this._hide();
        return;
      }
      var myGen = ++this._gen;
      try {
        var resp = await window.V4cClient.complete({ query: q, limit: 8 });
        if (myGen !== this._gen) return;
        this._render(resp.completions);
      } catch (e) {
        console.warn('[v4c-search-suggestion] complete failed', e);
        this._hide();
      }
    }

    _render(completions) {
      var html = buildSuggestionsHtml(completions);
      if (!html) {
        this._hide();
        return;
      }
      this.innerHTML = html;
      this.hidden = false;
    }

    _hide() {
      this.innerHTML = '';
      this.hidden = true;
    }

    // blur 時に即 hide すると mousedown→mouseup 中に消えてリンク click が
    // 拾えない。150ms 遅延して、その間に focus が戻ったらキャンセル。
    _delayHide() {
      var self = this;
      setTimeout(function () {
        if (document.activeElement === self.input) return;
        self._hide();
      }, 150);
    }
  }

  customElements.define('v4c-search-suggestion', V4cSearchSuggestion);
})();
